<template>
  <NewComponentLayout>
    <template #title>
      {{ $t('newcomponent.type.title') }}
    </template>

    <div id="NewComponentType">
      <ComponentTypeForm :excludeTypes="['custom']" />
    </div>

    <template #linkPrevious>
      <SecondaryButton @click="router.back()">
        {{ $t('newcomponent.type.cancel') }}
      </SecondaryButton>
    </template>

    <template #linkNext>
      <PrimaryLink :to="{
        name: 'NewComponentDates'
      }">
        {{ $t('newcomponent.type.next') }}
      </PrimaryLink>
    </template>
  </NewComponentLayout>

</template>
<script setup lang="ts">
import NewComponentLayout from '../../layouts/NewComponentLayout.vue';
import PrimaryLink from '../../components/links/PrimaryLink.vue';
import SecondaryButton from '../../components/buttons/SecondaryButton.vue';
import ComponentTypeForm from '../../components/form/ComponentTypeForm.vue'
import { useRouter } from 'vue-router';

const router = useRouter();
</script>